import React from 'react';
import {dataService} from "services/data.service"
import Plot from "react-plotly.js"
import { useTranslation } from 'react-i18next'

function GraphCell({drug, effect, scale, last}) {
	const { t } = useTranslation();
	const datapoint = dataService.getDatapoint(drug, effect)


	const complete = datapoint.mean !== ""
	const color = coloring(scale.max, datapoint.mean, complete, datapoint.type === "efficacy")
	// New line: Create a text string with the mean value for the hover label
	const hoverTextMean = complete ? Number(datapoint.mean).toFixed(2) : "";	const sideEffectClass = effect => effect !== "EFFICACY" ? "sideeffect" : ""
	const blackline_x = effect === "WEIGHT_GAIN" ? 0 : 1

	const data = complete ? [
		{
			x: [blackline_x, blackline_x],
			y: [-5, 5],
			mode: "lines",
			type: "scatter",
			name: "black-line",
			marker: {
				color: "black",
			}
		},
		{
			x: [datapoint.ci_lb || 0, datapoint.ci_up || 0],
			y: [0, 0],
			mode: "lines",
			type: "scatter",
			name: "confidence-interval",
			marker: {
				color: color,
			}
		},
		{
			x: [datapoint.mean || 0],
			y: [0],
			mode: "markers",
			type: "scatter",
			name: "mean",
			marker: {
				size: 15,
				color: color,
				symbol: 'diamond'
			}
		},
		// Other traces for the black line and confidence interval with hoverinfo set to 'none'
		complete && {
			x: [datapoint.ci_lb || 0, datapoint.ci_up || 0],
			y: [0, 0],
			mode: "lines",
			type: "scatter",
			name: "confidence-interval",
			hoverinfo: "none", // No hover text for CI
			marker: {
				color: color,
			}
		},
		// Mean marker trace with hover text
		complete && {
			x: [datapoint.mean || 0],
			y: [0],
			mode: "markers",
			type: "scatter",
			name: "mean",
			text: hoverTextMean, // Display rounded mean value on hover
			hoverinfo: "text", // Show hover text only for this marker
			hoverlabel: { // Custom hover label styling
				bgcolor: 'rgb(72,110,249)', // Blue background
				font: {
					size: 16, // Larger text size
					color: 'white' // White text
				},
				bordercolor: 'rgb(72,110,249)' // Blue border, same as background
			},
			marker: {
				size: 15,
				color: color,
				symbol: 'diamond'
			}
		}
	] : [
		{
			x: [1, 1],
			y: [-5, 5],
			mode: "lines",
			type: "scatter",
			name: "black-line",
			marker: {
				color: "black",
			}
		}
	].filter(Boolean); // This filters out any false values that resulted from the above conditions.

	const config = {
		displayModeBar: false,
		staticPlot: false
	}

	const text = effect === "WEIGHT_GAIN" ? "kg" : (effect === "EFFICACY" ? t("relativeefficacy") : t("relativerisk"))
	const range = effect === "WEIGHT_GAIN" ? -1.2 : -0.2


	const annotations = last ? [{
		xref: "paper",
		yref: "paper",
		x:1,
		xanchor: "right",
		y: -0.75,
		yanchor: "bottom",
		text: text,
		font: {
			fontSize: 16
		},
		showarrow: false
	}] : []

	const layout = {
		showlegend: false,
		xaxis: {
			range: [range, scale.max],
			showticklabels: last,
			fixedrange: true, // Prevents zooming and panning on the x-axis
		},
		yaxis: {
			range: [-1, 1],
			dtick: 1,
			showticklabels: false,
			fixedrange: true, // Prevents zooming and panning on the y-axis
		},
		margin: {
			l: 20,
			r: 20,
			b: last ? 40 : 0,
			t: 0,
		},
		width: scale.width,
		height: last ? 90 : 50,
		annotations: annotations
	}

	return (
		<div style={{height: last ? 90 : 50, width: scale.width}}
			 className={`graph-cell ${drug} ${effect} ${last} ${sideEffectClass(effect)}`}>
			<Plot
				data={data}
				layout={layout}
				config={config}
			/>
		</div>
	);
}

function coloring(max, mean, complete, reverse) {
	if (!complete) {
		return "gray"
	} else {
		let red_green = (mean / max) * 255
		if (reverse) {
			red_green = 255 - red_green
		}
		return "rgb(" + red_green + "," + red_green + ",255)"
	}
}

export const MemoizedGraphCell = React.memo(GraphCell)
